module.exports = __webpack_public_path__ + "img/box-bonifica.63e54044.jpg";